module.exports = __webpack_public_path__ + "static/title-339e03342ecbc0c3292afa2b76cd4f67.png";